import { withStyles } from '@material-ui/core/styles';
import { connect } from 'formik';
import * as _ from 'lodash';
import propTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  getErrorLabelForPath,
  getErrorLabelForPathObject,
  pathHasError
} from '../../utils/form-utils';
import IconWithTooltip from '../IconWithTooltip';
import Autocomplete from './Autocomplete';

const AutocompleteWithFormik = ({
  classes,
  formik,
  name,
  label,
  required,
  textFieldProps,
  i18n,
  tReady,
  isObjectValue,
  // If these props are passed, it'll calculate the options and value for the autocomplete
  rawOptions,
  valueKey,
  labelKey,
  // These props defeat the keys and rawOptions. Won't try to know what's current value and options
  value,
  options,
  ...props
}) => {
  const { t } = useTranslation();
  const error = pathHasError(name, formik.touched, formik.errors);
  let helperText;
  const defaultValue = '';
  let effectiveOptions = props.loadOptions || options;
  let effectiveValue = value || _.get(formik.values, name) || defaultValue;

  if (isObjectValue) {
    helperText = getErrorLabelForPathObject(
      name,
      formik.touched,
      formik.errors,
      valueKey,
      t
    );
    effectiveOptions = (effectiveOptions || []).map(o => ({
      label: o[labelKey || 'label'],
      value: o
    }));
    if (effectiveValue) {
      effectiveValue = {
        label: effectiveValue[labelKey || 'label'],
        value: effectiveValue
      };
    }
  } else {
    helperText = getErrorLabelForPath(name, formik.touched, formik.errors, t);
  }

  // If parent specifies the following props, we can infer what are the actual
  // options and the value from the raw options array, and the keys for
  // label and value
  if (rawOptions && valueKey && labelKey) {
    effectiveOptions = (rawOptions || []).map(o => ({
      label: o[labelKey],
      value: o[valueKey]
    }));
    const valueFromFormik = _.get(formik.values, name);
    effectiveValue = {
      value: valueFromFormik,
      label: valueFromFormik
        ? rawOptions.find(e => e[valueKey] === valueFromFormik)[labelKey]
        : ''
    };
  }

  const onBlur = () => formik.setFieldTouched(name);
  const onChange = async v => {
    await formik.setFieldValue(
      name,
      // eslint-disable-next-line no-nested-ternary
      v ? (isObjectValue ? v.value : v) : defaultValue
    );
    formik.setFieldTouched(name, true);
    if (props.afterChange) {
      // eslint-disable-next-line no-nested-ternary
      props.afterChange(v ? (isObjectValue ? v.value : v) : defaultValue);
    }
  };
  const innerProps = {
    name,
    id: name,
    options: effectiveOptions,
    value: effectiveValue,
    onBlur,
    onChange,
    fullWidth: true,
    placeholder: 'Seleccione...'
  };
  const autocompleteProps = { ...innerProps, ...props };
  const fieldProps = {
    InputLabelProps: {
      shrink: true
    },
    label: props.tooltip ? (
      <>
        {label} <IconWithTooltip title={props.tooltip} />
      </>
    ) : (
      label
    ),
    required,
    error,
    helperText: helperText || ' ',
    readOnly: !props.disabled,
    ...(textFieldProps || {})
  };
  return <Autocomplete {...autocompleteProps} textFieldProps={fieldProps} />;
};

AutocompleteWithFormik.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string,
  rawOptions: propTypes.array,
  valueKey: propTypes.string,
  labelKey: propTypes.string
};

const styles = () => ({});

export default withStyles(styles)(connect(AutocompleteWithFormik));
